import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { signInUrl } from './return-url';

/** Réserve `/admin` aux comptes du groupe Cognito `admins`. */
export const adminGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  if (!auth.isAuthenticated()) {
    return inject(Router).parseUrl(signInUrl(state.url));
  }
  const groups = auth.profile()?.groups ?? [];
  if (groups.includes('admins')) {
    return true;
  }
  return inject(Router).parseUrl('/');
};
